import React, { useEffect, useState } from 'react';
import Form from '../../../common/Form';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { closeModalAction } from '../../../actions/modal';
import Select from '../../../common/Form/Select';
import Radio from '../../../common/Form/Radio';
import Input from '../../../common/Form/Input';
import { updateProjectDetail } from '../../../actions/project';
import moment from 'moment';

const formName = 'add_sla';

const enable = { value: 'enable', name: 'sla_status', label: 'Enable' }
const disable = { value: 'disable', name: 'sla_status', label: 'Disable' }
const slaOptions = [enable, disable];

export default function AddSla({ projectId }) {
    const dispatch = useDispatch();
    const { formButtonLoading } = useSelector((state) => state.loading);
    const { projectsSlas } = useSelector((state) => state.project);
    const [daysBetween, setDaysBetween] = useState([]);


    const defaultValues = {
        sla: slaOptions[0].value,
        sla_type: 'CITY',
    };

    const methods = useForm({ defaultValues, mode: 'all' });
    const { watch, setValue } = methods;

    useEffect(() => {
        const sla = projectsSlas[projectId]
        if (sla) {
            const { is_applicable, tier_1, tier_2, tier_3, tier_4, sla_type, wh_end_time, wh_start_time } = sla
            setValue('sla', is_applicable ? enable.value : disable.value);
            setValue('sla_type', sla_type)
            setValue('wh_end_time', timeSlots.find(({ continentalFormat }) => {
                return continentalFormat === addHoursToTime(wh_end_time, 5.5).trim();
            }))
            setValue('wh_start_time', timeSlots.find(({ continentalFormat }) => {
                return continentalFormat === addHoursToTime(wh_start_time, 5.5).trim();
            }))
            setValue('tier_1', tier_1)
            setValue('tier_2', tier_2)
            setValue('tier_3', tier_3)
            setValue('tier_4', tier_4)
        }
    }, [projectsSlas, projectId, setValue])

    const slaValue = watch('sla');


    const submit = (formValues) => {
        let { wh_end_time, wh_start_time, tier_1, tier_2, tier_3, tier_4, sla, sla_type, start_week, end_week } = formValues;
        const startIndex = weekDays.findIndex((day) => day.value === start_week?.value);

        const endIndex = weekDays.findIndex((day) => day.value === end_week?.value);

        if (startIndex === -1 || endIndex === -1) {
            console.error("Invalid start or end week selection");
            return;
        }

        let result = [];
        if (startIndex <= endIndex) {
            result = weekDays.slice(startIndex, endIndex + 1);
        } else {
            result = [...weekDays.slice(startIndex), ...weekDays.slice(0, endIndex + 1)];
        }

        setDaysBetween(result);
        let timeframes = [{
            "site_type": "TIER1",
            "resolve_in_seconds": tier_1 * 60 * 60
        }, {
            "site_type": "TIER2",
            "resolve_in_seconds": tier_2 * 60 * 60
        }, {
            "site_type": "TIER3",
            "resolve_in_seconds": tier_3 * 60 * 60
        }, {
            "site_type": "TIER4",
            "resolve_in_seconds": tier_4 * 60 * 60
        }]
        let payload = { work_start_time: wh_start_time.value, work_end_time: wh_end_time.value, timeframes, work_week: result.map((day) => day.value) }
        dispatch(updateProjectDetail({ projectId, projectForm: payload, formName }))

    }

    return <Form
        methods={methods}
        onSubmit={submit}
        submitButtonText={'Submit'}
        onCancel={() => dispatch(closeModalAction())}
        showSubmit
        submitContainerClassName='flex gap-2 justify-end py-4 px-4'
        isLoading={formButtonLoading[formName]}
    >
        <div className='px-3'>
            <Radio className='flex flex-row gap-2 items-center' name='sla' label='SLA' id='sla' options={slaOptions} />
        </div>
        {slaValue === enable.value && <div className='px-3'>
            <div className='grid grid-cols-4 rows-fr grid-flow-row-dense '>
                <Input label='T1' name='tier_1' required type='number' />
                <Input label='T2' name='tier_2' required type='number' />
                <Input label='T3' name='tier_3' required type='number' />
                <Input label='T4' name='tier_4' required type='number' />
            </div>
            <p className={'font-normal text-font09 md:text-font11 px-1 pt-2 pb-1'}>Working Hour</p>
            <div className='grid grid-cols-4 rows-fr grid-flow-row-dense '>
                <Select required isLoading={false} label='Start Time' name='wh_start_time' options={timeSlots} />
                <Select required isLoading={false} label='End TIie' name='wh_end_time' options={timeSlots} />
                <Select required isLoading={false} label='Start Week' name='start_week' options={weekDays} />
                <Select required isLoading={false} label='End Week' name='end_week' options={weekDays} />

            </div>
        </div>}
    </Form>
}



const timeSlots = [
    { "key": 0, "label": "08:00 AM", "value": "T0800", "continentalFormat": "08.00" },
    { "key": 1, "label": "08:30 AM", "value": "T0830", "continentalFormat": "08.30" },
    { "key": 2, "label": "09:00 AM", "value": "T0900", "continentalFormat": "09.00" },
    { "key": 3, "label": "09:30 AM", "value": "T0930", "continentalFormat": "09.30" },
    { "key": 4, "label": "10:00 AM", "value": "T1000", "continentalFormat": "10.00" },
    { "key": 5, "label": "10:30 AM", "value": "T1030", "continentalFormat": "10.30" },
    { "key": 6, "label": "11:00 AM", "value": "T1100", "continentalFormat": "11.00" },
    { "key": 7, "label": "11:30 AM", "value": "T1130", "continentalFormat": "11.30" },
    { "key": 8, "label": "12:00 PM", "value": "T1200", "continentalFormat": "12.00" },
    { "key": 9, "label": "12:30 PM", "value": "T1230", "continentalFormat": "12.30" },
    { "key": 10, "label": "01:00 PM", "value": "T1300", "continentalFormat": "13.00" },
    { "key": 11, "label": "01:30 PM", "value": "T1330", "continentalFormat": "13.30" },
    { "key": 12, "label": "02:00 PM", "value": "T1400", "continentalFormat": "14.00" },
    { "key": 13, "label": "02:30 PM", "value": "T1430", "continentalFormat": "14.30" },
    { "key": 14, "label": "03:00 PM", "value": "T1500", "continentalFormat": "15.00" },
    { "key": 15, "label": "03:30 PM", "value": "T1530", "continentalFormat": "15.30" },
    { "key": 16, "label": "04:00 PM", "value": "T1600", "continentalFormat": "16.00" },
    { "key": 17, "label": "04:30 PM", "value": "T1630", "continentalFormat": "16.30" },
    { "key": 18, "label": "05:00 PM", "value": "T1700", "continentalFormat": "17.00" },
    { "key": 19, "label": "05:30 PM", "value": "T1730", "continentalFormat": "17.30" },
    { "key": 20, "label": "06:00 PM", "value": "T1800", "continentalFormat": "18.00" },
    { "key": 21, "label": "06:30 PM", "value": "T1830", "continentalFormat": "18.30" },
    { "key": 22, "label": "07:00 PM", "value": "T1900", "continentalFormat": "19.00" },
    { "key": 23, "label": "07:30 PM", "value": "T1930", "continentalFormat": "19.30" },
    { "key": 24, "label": "08:00 PM", "value": "T2000", "continentalFormat": "20.00" },
    { "key": 25, "label": "08:30 PM", "value": "T2030", "continentalFormat": "20.30" },
    { "key": 26, "label": "09:00 PM", "value": "T2100", "continentalFormat": "21.00" },
    { "key": 27, "label": "09:30 PM", "value": "T2130", "continentalFormat": "21.30" },
    { "key": 28, "label": "10:00 PM", "value": "T2200", "continentalFormat": "22.00" }
]
const weekDays = [{ 'key': 0, 'value': 'MONDAY', 'label': 'MONDAY' }, { 'key': 1, 'value': 'TUESDAY', 'label': 'TUESDAY' }, { 'key': 2, 'value': 'WEDNESDAY', 'label': 'WEDNESDAY' }, { 'key': 3, 'value': 'THURSDAY', 'label': 'THURSDAY' }, { 'key': 4, 'value': 'FRIDAY', 'label': 'FRIDAY' }, { 'key': 5, 'value': 'SATURDAY', 'label': 'SATURDAY' }, { 'key': 6, 'value': 'SUNDAY', 'label': 'SUNDAY' }]



function addHoursToTime(timeStr, hoursToAdd) {
    const [hours, minutes] = timeStr.split('.').map(Number);

    // Create a moment object with today's date and the given time
    const timeMoment = moment().set({ hour: hours, minute: minutes });

    // Add 5.5 hours to the time
    const adjustedTime = timeMoment.add(hoursToAdd, 'hours');
    // Format the adjusted time back to HH.MM format
    const formattedTime = adjustedTime.format('HH.mm');
    return formattedTime;
}